"use client";

import Title from "@/components/ui/title";
import { Container } from "@/components/ui/container";
import { useTranslations } from "next-intl";
import { ButtonLink } from "@/components/ui/button";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import NewsCard from "@/views/home/components/news/news-card";
import S from "./index.module.scss";
import { useHomeData } from "../../hooks/useHomeData";

dayjs.locale("ru");

const News = () => {
  const t = useTranslations("home");
  const { news, newsLoading } = useHomeData();

  if (!news || newsLoading) return null;

  return (
    <div className={S.newsWrapper}>
      <Container>
        <Title variant="black">{t("news")}</Title>
      </Container>
      <div className={S.newsWrap}>
        <div className={S.newsBorderWrap}>
          <div className={S.newsGrid}>
            {news.map(item => (
              <NewsCard news={item} key={item.id} />
            ))}
          </div>
        </div>
        <ButtonLink variant="trBlackToBlack" href="/news" arrow className={S.buttonWrapper}>
          {t("allNews")}
        </ButtonLink>
      </div>
    </div>
  );
};

export default News;
